import { IProfileStory } from "@/store/models/books.models";
import React from "react";
import { Card } from "./components/Card/Card";

export const getDataByType = (
  profileStories: IProfileStory[] | undefined,
  type: string
) => {
  return profileStories?.filter((story) => story.name === type);
};

export const getButtonLabel = (type: string) => {
  return `Add ${type.toLowerCase()}`;
};

export const renderCards = (
  data: IProfileStory[] | undefined,
  type: string
) => {
  return data?.map((item) =>
    item.options.map((option) => (
      <React.Fragment key={option.uid}>
        <Card type={type} option={option} profileStory={data} />
      </React.Fragment>
    ))
  );
};

export const getCategoryIdByType = (
  profileStories: IProfileStory[] | undefined,
  type: string
) => {
  const story = profileStories?.find((story) => story.name === type);
  return story?.uid || "";
};

